import React, {Component} from 'react'
import style from './ṔhotoPreview.less'
import Card from '../../core/components/Card'

class PhotoPreview  extends Component {
    state = {}

    popoverPhoto = (photo) => {
        return () => (this.setState({photo}))
    }

    close = () => {
        this.setState({
            photo: undefined
        })
    }

    renderPhoto = (photo) => {
        return (
            <figure>
                <img src={photo.url} width={200} onMouseEnter={this.popoverPhoto(photo.url)} onClick={this.popoverPhoto(photo.url)}/>
            </figure>
        )
    }

    renderPopover = () => {
        return this.state.photo ? (
            <div className={style.popover} onClick={this.popoverPhoto()}>
                <span>Chargement ...</span>
                <img src={this.state.photo} onMouseLeave={this.popoverPhoto()}/>
            </div>
        ) : undefined
    }

    render() {
       const { photos } = this.props

       return photos.length > 0 ? (
           <section className={style.photoPreview}>
               <Card header={(<h5>Photos envoyées lors de la demande</h5>)}>
                {photos.map(this.renderPhoto)}
                {this.renderPopover()}
               </Card>
           </section>
       ) : (<div></div>)
    }
}

export default PhotoPreview


// WEBPACK FOOTER //
// ./lib/ticket/components/PhotoPreview.js